// extracted by mini-css-extract-plugin
export var borderRadius = "_eh-4";
export var large = "_eh-3";
export var logoContainer = "_eh-0";
export var nameLogo = "_eh-2";
export var small = "_eh-1";